<template>
    <v-container
        id="service-card"
        fluid
        tag="section"
        pt-0
    >
        <v-row class="mt-1" justify="center">
            <v-col cols="12" :md="5" class="pt-3">
                <base-material-card>
                    <template v-slot:heading>
                        <div class="subtitle-1 font-weight-light d-flex">
                            <div>
                                <v-tooltip
                                    v-model="copyLinkSuccess"
                                    right
                                    internal-activator
                                    :open-on-hover="false"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    <span @click="copyLink" v-bind="attrs"
                                          v-on="on">{{ formTitle }}</span>
                                    </template>
                                    {{ $vuetify.lang.t('$vuetify.page.action.copyLinkSuccess') }}
                                </v-tooltip>
                            </div>
                        </div>
                    </template>
                    <div class="mt-2">
                        <v-row>
                            <v-col
                                cols="12">
                                <v-select
                                    dense
                                    outlined
                                    readonly
                                    :label="$vuetify.lang.t('$vuetify.page.ClientTicketCard.fields.status')"
                                    v-model="currentClientTicket.ticketStatus.id"
                                    :items="ticketStatusList"
                                    item-text="name"
                                    item-value="id"
                                    hide-details="auto"
                                >
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="12"
                            >
                                <v-text-field
                                    v-model="currentClientTicket.name"
                                    :label="$vuetify.lang.t('$vuetify.page.ClientTicketCard.fields.name')"
                                    readonly
                                    outlined
                                    dense
                                    hide-details="auto"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="12">
                                <v-textarea
                                    :label="$vuetify.lang.t('$vuetify.page.ClientTicketCard.fields.description')"
                                    v-model="currentClientTicket.description"
                                    dense
                                    readonly
                                    outlined
                                    hide-details="auto"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                        <v-card-actions class="px-0" v-if="currentClientTicket.manager && currentClientTicket.ticketStatus.id !== 3">
                            <v-spacer></v-spacer>
                            <v-btn color="primary" class="ma-0" @click="closeClientTicket">Закрыть обращение</v-btn>
                        </v-card-actions>
                    </div>
                </base-material-card>
            </v-col>
            <v-col cols="12" md="7">
                <chat-panel></chat-panel>
                <chat-multi-media-show></chat-multi-media-show>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ChatPanel from "@/view/dashboard/components/chat/ChatPanel";

export default {
    name: "ClientTicketCard",
    components: {
        ChatPanel,
        ChatMultiMediaShow: () => import('@/view/dashboard/components/chat/ChatMultiMediaShow'),
    },
    props: {
        clientId: String,
        ticketId: String
    },
    created() {
        this.$store.dispatch('retrieveClientTicket', {clientId: this.clientId, tickedId: this.ticketId}).then(() => {
            this.$nextTick(() => {
                if (this.currentClientTicket.activity) {
                    this.$store.dispatch('retrieveChat', {
                        chatId: this.currentClientTicket.activity.id,
                        commentLimit: 20
                    })
                }
            })
        })
    },
    beforeDestroy: function () {
        this.$store.dispatch('leaveGroup').then(() =>
            this.$store.dispatch('retrieveChat', null)
        )
    },
    computed: {
        currentClientTicket() {
            return this.$store.getters.currentClientTicket
        },
        formTitle() {
            return this.currentClientTicket ? this.currentClientTicket.no : ''
        },
    },
    data() {
        return {
            ticketStatusList: [
                {id: 1, name: 'Открыта'},
                {id: 2, name: 'В процесе'},
                {id: 3, name: 'Закрыта'},
            ],
            valid: !this.formError,
            vue: this,
            copyLinkSuccess: false,
            goToService: false,
            editMode: false,
        }
    },
    methods: {
        copyLink() {
            this.copyToClipboard(window.location.href)
            this.copyLinkSuccess = true
            setTimeout(() => {
                this.copyLinkSuccess = false
            }, 2000);
        },
        showClientCard() {
            if (!this.currentClientTicket.client) {
                return
            }
            let clientId = this.currentClientTicket.client.id
            let routeData = this.$router.resolve({
                name: 'ClientsCard',
                params: {clientId}
            });
            window.open(routeData.href, '_blank');
        },
        closeClientTicket(){
            this.$store.dispatch('changeClientTicketStatus', {
                clientId: this.clientId,
                tickedId: this.ticketId,
                ticketStatusId: 3
            })
        }
    }
}
</script>

<style scoped>

</style>